import { Component } from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import JSONTree from "react-json-tree";

class SystemRestartComponent extends Component {
  render() {
    return (
      <div>
        <h3>Event router restart</h3>{" "}
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.restartRouter}
        >
          {" "}
          Restart event router
        </Button>
        <hr />
        {this.props.browser.routerRestart.fetching ? (
          <div className="restart-status">
            <CircularProgress />
          </div>
        ) : this.props.browser.routerRestart.fetched ? (
          <div className="restart-status">
            <JSONTree
              data={this.props.browser.routerRestart.data}
              hideRoot={true}
            />
          </div>
        ) : (
          <div />
        )}
        <h3>Projections restart</h3>{" "}
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.restartProjections}
        >
          {" "}
          Restart projections
        </Button>
        <hr />
        {this.props.browser.projectionsRestart.fetching ? (
          <div className="restart-status">
            <CircularProgress />
          </div>
        ) : this.props.browser.projectionsRestart.fetched ? (
          <div className="restart-status">
            <JSONTree
              data={this.props.browser.projectionsRestart.data}
              hideRoot={true}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}
export default SystemRestartComponent;
